// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { Integrations } from "@sentry/tracing";
import { ReportingObserver as ReportingObserverIntegration } from "@sentry/integrations";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

const online = ENV_ISONLINE;
const isProd = ENV_ISPROD;

console.log("online", online)
console.log("isProd", isProd)

function replacePathname(pathname = "") {
	if (pathname.match(/\/active\//)) {
		return "/active";
	}
	return pathname;
}

const integrations = [
	new ReportingObserverIntegration(),
	new Integrations.BrowserTracing({
		beforeNavigate: (context) => {
			return {
				...context,
				name: replacePathname(location.pathname),
			};
		},
	}),
];

Sentry.init({
  serverName: "OPTIMUS-OUKU",
  integrations,
  dsn: SENTRY_DSN || 'https://5c90502ea8c04a75be7fa6377db81172@sentry.ezbuy.com/52',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  environment: online ? "online" : isProd ? "dev" : "test",
});
